import {AbstractEntity} from './abstract-entity.model';

export class SimpleEntity extends AbstractEntity {
    name: string;
    image: string;
    icon: string;
    hints: string[];
}
